export default class BuildInfo { static buildNumber = "OpsBoard_develop_20260429.1"; }
